<template>
  <div class="vx-card p-6">
    <h1 class=" text-center mt-5 mb-5">Satın Alma</h1>
    <form-wizard color="rgba(var(--vs-primary), 1)" finishButtonText="Kaydet" backButtonText="Geri" nextButtonText="İleri" ref="formWizard" stepSize="xs" shape="tab" @on-complete="formSubmitted" @on-change="formWizardPageChanged">
      <!--***************************************** tab 1 content****************************************************** -->
      <tab-content title="Satın Alınacak Ürünler" class="mb-5" icon="feather icon-codepen" :before-change="validateAsync" lazy="true">
        <ag-grid-vue
          ref="agGridTable"
          class="ag-theme-material ag-grid-table"
          rowSelection="multiple"
          rowMultiSelectWithClick="true"
          :localeText="localeText"
          :gridOptions="gridOptions"
          :getRowHeight="getRowHeight"
          :defaultColDef="defaultColDef"
          :columnDefs="columnDefs"
          :floatingFilter="true"
          :rowData="productStockList"
          :isFullWidthCell="isFullWidthCell"
          :fullWidthCellRenderer="fullWidthCellRenderer"
          id="myGrid"
          :pagination="true"
          :paginationPageSize="20"
          @gridSizeChanged="onGridSizeChanged"
          @grid-ready="onGridReady"
        ></ag-grid-vue>
        <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
        <div class="vx-row justify-end flex">
          <div class="vx-col">
            <vs-button size="small" type="border" @click="clearAllSelectedProducts()">Seçilenleri Temizle</vs-button>
          </div>
          <div class="vx-col">
            <vs-button size="small" type="border" @click="selectDisplayedProducts()">Ekrandakileri Seç</vs-button>
          </div>
          <div class="vx-col">
            <vs-button size="small" type="border" @click="selectFilteredProducts()">Filtrelenenleri Seç</vs-button>
          </div>
          <div class="vx-col">
            <vs-button size="small" type="filled" icon-pack="feather" icon="icon-chevron-right" @click="$refs.formWizard.nextTab()">İleri</vs-button>
          </div>
        </div>
      </tab-content>

      <!--***************************************** tab 2 content****************************************************** -->
      <tab-content title="Miktar, Fiyat ve Tedarik Bilgileri" icon="feather icon-dollar-sign" :before-change="beforeChangeForTab2">
        <div>
          <div class="vx-row flex mt-10">
            <div class="vx-col flex items-center" style="width: 20%;">
              Ürün Adı
            </div>
            <div class="vx-col flex items-center" style="width: 10%;">
              Sipariş Miktarı
            </div>
            <div class="vx-col flex items-center" style="width: 10%;">
              Miktar Türü
              <vs-button class="ml-3" size="small" type="border" @click="makeAllAmountTypeFirstRow()">Yansıt</vs-button>
            </div>

            <div class="vx-col flex items-center" style="width: 10%;">
              Birim Fiyat
            </div>

            <div class="vx-col flex items-center" style="width: 10%;">
              Döviz Türü
              <div class="ml-3">
                <vs-button size="small" type="border" @click="makeAllCurrencyFirstRow()">Yansıt</vs-button>
              </div>
            </div>

            <div class="vx-col flex items-center" style="width: 10%;">
              TL Kur
              <div class="ml-3">
                <vs-button size="small" type="border" @click="makeAllFxRateFirstRow()">Yansıt</vs-button>
              </div>
            </div>

            <div class="vx-col flex items-center" style="width: 15%;">
              Tedarikçi Firma
              <vs-button class="ml-3" size="small" type="border" @click="makeAllSupplierFirstRow()">Yansıt</vs-button>
            </div>
            <div class="vx-col flex items-center" style="width: 15%;">
              Teslim Depo
              <div class="ml-3">
                <vs-button size="small" type="border" @click="makeAllWarehouseFirstRow()">Yansıt</vs-button>
              </div>
            </div>
          </div>

          <div>
            <div v-for="(tr, i) in selectedRows" :key="i" class="vx-row flex mt-10">
              <div style="width: 20%;" class="vx-col flex items-center">
                {{ tr.productName }}
              </div>

              <div style="width: 10%;" class="vx-col flex items-center">
                <vs-input size="small" type="number" v-model="tr.purchaseAmount" />
              </div>

              <div style="width: 10%;" class="vx-col flex items-center">
                <v-select
                  name="amountTypeSelection"
                  v-model="tr.purchaseAmountTypeId"
                  placeholder="Miktar Tür"
                  :options="productAmountTypeList"
                  label="productAmountTypeName"
                  class="w-full"
                  :reduce="(amount) => amount.productAmountTypeId"
                  @input="$event != undefined ? (tr.purchaseAmountTypeName = productAmountTypeList.find((r) => r.productAmountTypeId == $event).productAmountTypeName) : undefined"
                >
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>

              <div style="width: 10%;" class="vx-col flex items-center">
                <vs-input size="small" type="number" v-model="tr.purchaseUnitPrice" />
              </div>

              <div style="width: 10%;" class="vx-col flex items-center">
                <v-select
                  name="currencyId"
                  placeholder="Kur"
                  label="currencyName"
                  v-model="tr.purchaseCurrencyId"
                  :options="currencyList"
                  :reduce="(currency) => currency.currencyId"
                  @input="$event != undefined ? (tr.purchaseCurrencyName = currencyList.find((r) => r.currencyId == $event).currencyName) : undefined"
                  class="w-full"
                >
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>

              <div style="width: 10%;" class="vx-col flex items-center">
                <vs-input size="small" type="number" v-model="tr.purchaseFxRate" />
              </div>

              <div style="width: 15%;" class="vx-col flex items-center">
                <v-select
                  placeholder="Tedarikçi"
                  label="supplierName"
                  v-model="tr.purchaseSupplierId"
                  :options="supplierList"
                  :reduce="(supplier) => supplier.supplierId"
                  @input="$event != undefined ? (tr.purchaseSupplierName = supplierList.find((r) => r.supplierId == $event).supplierName) : undefined"
                  class="w-full"
                >
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>

              <div style="width: 15%;" class="vx-col flex items-center">
                <v-select
                  name="warehouseId"
                  placeholder="Teslim Depo"
                  label="warehouseName"
                  v-model="tr.purchaseWarehouseId"
                  :options="warehouseList"
                  :reduce="(warehouse) => warehouse.warehouseId"
                  @input="$event != undefined ? (tr.purchaseWarehouseName = warehouseList.find((r) => r.warehouseId == $event).warehouseName) : undefined"
                  class="w-full"
                >
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>
            </div>
            <div class="vx-row flex mt-10">
              <div style="width: 5%;" class="vx-col flex">
                TOPLAM
              </div>

              <div style="width: 15%;" class="vx-col flex ">
                <span class="font-medium text-lg leading-none">
                  {{
                    selectedRows.reduce(function(total, item) {
                      return parseFloat(total) + parseFloat(item.purchaseUnitPrice) * parseFloat(item.purchaseAmount) + " " + (item.purchaseCurrencyName == null ? "" : item.purchaseCurrencyName);
                    }, 0)
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="vx-row justify-between flex mt-2">
          <div class="vx-col">
            <vs-button size="small" type="filled" icon-pack="feather" icon="icon-chevron-left" @click="$refs.formWizard.prevTab()">Geri</vs-button>
          </div>

          <div class="vx-col">
            <vs-button size="small" type="filled" icon-pack="feather" icon="icon-chevron-right" @click="$refs.formWizard.nextTab()">İleri</vs-button>
          </div>
        </div>
      </tab-content>

      <!-- ****************************************tab 3 content ********************************************************-->
      <tab-content title="Onayla" class="mb-5" icon="feather icon-upload" :on-complete="formSubmitted">
        <div class="flex items-end items-center px-3">
          <feather-icon svgClasses="w-6 h-6" icon="EyeIcon" class="mr-2" />
          <span class="font-medium text-lg leading-none">Değişen Değerler</span>
        </div>
        <vs-table search noDataText="Ürün Bulunamadı!" :data="selectedRows" maxHeight="280px" class="px-2">
          <template slot="header"></template>

          <template slot="thead">
            <vs-th>Ürün Adı</vs-th>
            <vs-th>Sipariş Miktar</vs-th>
            <vs-th>Birim Fiyat</vs-th>
            <vs-th>Döviz Türü</vs-th>
            <vs-th>TL Kur</vs-th>
            <vs-th>Tedarikçi Firma</vs-th>
            <vs-th>Teslim Depo</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr v-for="(tr, i) in data" :key="i">
              <vs-td style="width: 30%;">{{ tr.productName }}</vs-td>
              <vs-td style="width: 10%;">{{ tr.purchaseAmount + " " + tr.purchaseAmountTypeName }}</vs-td>
              <vs-td style="width: 10%;">{{ tr.purchaseUnitPrice }}</vs-td>
              <vs-td style="width: 10%;">{{ tr.purchaseCurrencyName }}</vs-td>
              <vs-td style="width: 10%;">{{ tr.purchaseFxRate }}</vs-td>
              <vs-td style="width: 15%;">{{ tr.purchaseSupplierName }}</vs-td>
              <vs-td style="width: 15%;">{{ tr.purchaseWarehouseName }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <div class="vx-row justify-between flex mt-2">
          <div class="vx-col">
            <vs-button size="small" type="filled" icon-pack="feather" icon="icon-chevron-left" @click="$refs.formWizard.prevTab()">Geri</vs-button>
          </div>

          <div class="vx-col">
            <vs-button size="small" type="filled" icon-pack="feather" icon="icon-chevron-right" v-if="purchaseList[0].purchaseStatus == 'T'" @click.native="formSubmitted">Kaydet</vs-button>
          </div>
        </div>
      </tab-content>
    </form-wizard>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import vSelect from "vue-select";
import { AgGridVue } from "ag-grid-vue";
import { repository } from "@/_services/repository.js";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";

const AG_GRID_LOCALE_TR = {
  equals: "Eşittir",
  notEqual: "Eşit Değildir",
  lessThan: "Daha Az",
  lessThanOrEqual: "Az veya Eşit",
  greaterThan: "Büyüktür",
  greaterThanOrEqual: "Büyük veya Eşit",
  inRange: "İçinde",

  contains: "İçerir",
  notContains: "İçermez",
  startsWith: "İle Başlar",
  endsWith: "İle Biter",

  andCondition: "ve",
  orCondition: "veya",

  filterOoo: "Filtre",

  to: "-",
  of: " / ",
  page: "Sayfa",
};

export default {
  components: {
    FormWizard,
    TabContent,
    vSelect,
    AgGridVue,
  },
  data() {
    return {
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      maxPageNumbers: 8,
      gridOptions: {
        // onFilterChanged: function (ev) {
        //   console.log(ev.api.rowModel.rowsToDisplay);
        // },
      },
      purchaseId: undefined,
      searchName: undefined,
      supplierList: [],
      currencyList: [],
      warehouseList: [],
      productAmountTypeList: [],
      supplierPageNumber: 1,
      gridApi: null,
      columnApi: null,
      isFullWidthCell: null,
      fullWidthCellRenderer: null,
      getRowHeight: null,
      selectedRows: [],
      columnDefs: [
        {
          headerName: "Ürün Adı",
          field: "productName",
          filter: true,
          editable: false,
          checkboxSelection: true,
          width: 300,
        },
        {
          headerName: "Marka",
          field: "brand",
          filter: true,
          width: 100,
        },

        {
          headerName: "ProductId",
          field: "productId",
          filter: true,
          width: 150,
        },
      ],
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        editable: true,
      },

      purchaseList: [{ purchaseStatus: "T" }],
      productStockList: [],
      loading: true,
    };
  },
  watch: {
    $route(to, from) {
      if (to !== from) {
        location.reload();
      }
    },
  },
  created: async function() {
    await Promise.all([this.getProductStock(), this.getSupplier(), this.getWarehouse(), this.getProductAmountType(), this.getCurrency()]);
    this.gridApi.sizeColumnsToFit();
  },
  beforeMount() {
    this.localeText = AG_GRID_LOCALE_TR;
    this.getRowHeight = (params) => {
      if (params.data.header) {
        return 50;
      } else return 40;
    };
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
    this.gridApi.sizeColumnsToFit();

    document.getElementsByClassName("wizard-header")[0].style.display = "none";
    document.getElementsByClassName("wizard-card-footer")[0].style.display = "none";
    window.ab = this.$refs.formWizard;
  },

  computed: {
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },

  methods: {
    getPurchaseById: async function() {
      let result = await repository.getById("Purchase/getPurchaseById" + "/" + this.purchaseId, this.purchaseId);
      this.purchaseList = result.list;
      result.list.forEach((row) => {
        this.gridApi.forEachNode((node) => {
          if (node.data.productId === row.purchaseProductId) {
            node.data.purchaseAmount = row.purchaseAmount;
            node.data.purchaseAmountTypeName = row.purchaseAmountTypeName;
            node.data.purchaseAmountTypeId = row.purchaseAmountTypeId;

            node.data.purchaseCurrency = row.purchaseCurrency;
            node.data.purchaseCurrencyId = row.purchaseCurrencyId;
            node.data.purchaseCurrencyName = row.purchaseCurrencyName;

            node.data.purchaseFxRate = row.purchaseFxRate;
            node.data.purchaseUnitPrice = row.purchaseUnitPrice;

            node.data.purchaseSupplierName = row.purchaseSupplierName;
            node.data.purchaseSupplierId = row.purchaseSupplierId;

            node.data.purchaseWarehouseId = row.purchaseWarehouseId;
            node.data.purchaseWarehouseName = row.purchaseWarehouseName;

            node.setSelected(true);
          }
        });
      });
    },

    formWizardPageChanged: async function(prevIndex, nextIndex) {},
    onGridSizeChanged() {
      // this.gridApi.sizeColumnsToFit();
    },
    onGridReady() {
      //this.gridApi.sizeColumnsToFit();
    },
    getProductStock: async function() {
      let list = await repository.getAll("Purchase/getProductStock").then((r) => r.list);

      if (list) this.productStockList = list;
      else {
        this.$vs.notify({
          title: "Ürünler Çekilemedi",
          text: (list && list.hasExceptionError && list.exceptionMessage) || "bilinmeyen hata oluştu.",
          color: "danger",
          icon: "warning",
        });
      }

      //Güncelleme için URL den pruchaseId çekiliyor
      if (this.$route.params != null && this.$route.params.purchaseId > 0) {
        this.purchaseId = this.$route.params.purchaseId;
        this.getPurchaseById();
      }

      this.loading = false;
    },

    //tedarikçi firmları getirir
    getSupplier: async function() {
      let searchModel = {
        searchName: this.search,
        supplierPageNumber: this.supplierPageNumber,
      };

      let list = await repository.postEntity("Purchase/getSupplier", searchModel).then((r) => r.list);

      if (list) this.supplierList = list;
      else {
        this.$vs.notify({
          title: "Ürünler Çekilemedi",
          text: (list && list.hasExceptionError && list.exceptionMessage) || "bilinmeyen hata oluştu.",
          color: "danger",
          icon: "warning",
        });
      }
      this.loading = false;
    },

    //tedarikçi firmları getirir
    getCurrency: async function() {
      let list = await repository.getAll("Purchase/getCurrency").then((r) => r.list);

      if (list) this.currencyList = list;
      else {
        this.$vs.notify({
          title: "Para Birimleri Çekilemedi",
          text: (list && list.hasExceptionError && list.exceptionMessage) || "bilinmeyen hata oluştu.",
          color: "danger",
          icon: "warning",
        });
      }
      this.loading = false;
    },

    //tedarikçi firmları getirir
    getWarehouse: async function() {
      let searchModel = {
        searchName: "..",
        warehousePageNumber: 0,
        includeChargeWarehouse: 1,
      };

      let list = await repository.postEntity("Purchase/getWarehouse", searchModel).then((r) => r.list);

      if (list) this.warehouseList = list;
      else {
        this.$vs.notify({
          title: "Depo Bilgileri Çekilemedi",
          text: (list && list.hasExceptionError && list.exceptionMessage) || "bilinmeyen hata oluştu.",
          color: "danger",
          icon: "warning",
        });
      }
      this.loading = false;
    },

    getProductAmountType: async function() {
      let list = await repository.getAll("Purchase/getProductAmountType").then((r) => r.list);

      if (list) {
        this.productAmountTypeList = list;
      } else {
        this.$vs.notify({
          title: "Türler Çekilemedi",
          text: (list && list.hasExceptionError && list.exceptionMessage) || "bilinmeyen hata oluştu.",
          color: "danger",
          icon: "warning",
        });
      }
      this.loading = false;
    },

    formSubmitted: async function() {
      let postModel = this.selectedRows;

      postModel.forEach((row) => {
        row.purchaseId = this.purchaseId;
      });

      let result = await repository.postEntity("Purchase/savePurchase", postModel);

      if (result && result.isSuccessful) {
        this.$vs.notify({
          title: "Başarılı",
          text: "Talep kaydedildi. Talep Listesine Yönlendriliyorsunuz",
          color: "success",
        });
        this.$router.push("/PurchaseList");
      } else {
        this.$vs.notify({
          title: "Hata ",
          text: (result.exceptionMessage && `${result.exceptionMessage} `) || "Bağlantı hatası",
          color: "danger",
          fixed: true,
        });
      }
    },

    clearAllSelectedProducts() {
      this.gridOptions.api.deselectAll();
      this.selectedRows = [];
    },
    makeAllSupplierFirstRow() {
      this.selectedRows.forEach((row) => {
        row.purchaseSupplierId = this.selectedRows[0].purchaseSupplierId;
        row.purchaseSupplierName = this.selectedRows[0].purchaseSupplierName;
      });
    },

    makeAllCurrencyFirstRow() {
      this.selectedRows.forEach((row) => {
        row.purchaseCurrencyId = this.selectedRows[0].purchaseCurrencyId;
        row.purchaseCurrencyName = this.selectedRows[0].purchaseCurrencyName;
      });
    },

    makeAllFxRateFirstRow() {
      this.selectedRows.forEach((row) => {
        row.purchaseFxRate = this.selectedRows[0].purchaseFxRate;
      });
    },

    makeAllAmountTypeFirstRow() {
      this.selectedRows.forEach((row) => {
        row.purchaseAmountTypeId = this.selectedRows[0].purchaseAmountTypeId;
        row.purchaseAmountTypeName = this.selectedRows[0].purchaseAmountTypeName;
      });

      console.log(this.selectedRows);
    },

    makeAllWarehouseFirstRow() {
      this.selectedRows.forEach((row) => {
        row.purchaseWarehouseId = this.selectedRows[0].purchaseWarehouseId;
        row.purchaseWarehouseName = this.selectedRows[0].purchaseWarehouseName;
      });
    },

    //aktif olan sayfada gördüklerimizi seçmek için
    selectDisplayedProducts() {
      let urunler = this.gridApi.getRenderedNodes();
      for (let a = 0; a < urunler.length; a++) this.gridApi.getRowNode(urunler[a].id).setSelected(true);
    },

    //Filtrelenen ürünlerin seçilmesi için
    selectFilteredProducts() {
      let filtered = this.gridApi.rowModel.rowsToDisplay;
      for (let i = 0; i < filtered.length; i++) {
        this.gridApi.getRowNode(filtered[i].id).setSelected(true);
      }
    },

    beforeChangeForTab2: async function() {
      let validationResult = true;

      this.selectedRows.forEach((row) => {
        if (!row.purchaseAmount) {
          this.$vs.notify({
            title: "Hata",
            text: "Miktar Giriniz",
            color: "danger",
          });
          validationResult = false;
          return false;
        } else if (!row.purchaseAmountTypeId) {
          this.$vs.notify({
            title: "Hata",
            text: "Miktar Tür Giriniz",
            color: "danger",
          });
          validationResult = false;
          return false;
        } else if (!row.purchaseSupplierId) {
          this.$vs.notify({
            title: "Hata",
            text: "Tedarikçi Firma",
            color: "danger",
          });
          validationResult = false;
          return false;
        }
      });

      return validationResult;
    },

    validateAsync() {
      this.selectedRows = []; //ileri geri yaptığımızda sürekli ekleme yapıyordu. Bu sebeple öncesinde sıfırlıyoruz
      this.gridApi.getSelectedRows().forEach((rows) => this.selectedRows.push(rows));

      return true;
    },
  },
};
</script>
